export default __webpack_public_path__ + "static/media/lamp4.5cd596e1.webp";